// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2DSfz","header":"ReportDetails_header__31uf-","title":"ReportDetails_title__1fBN_","left":"ReportDetails_left__c4NWx"};